module.exports = __webpack_public_path__ + "img/qy2.7fe03e00.jpg";